import { history } from '@history';
import { FeaturesService, ModalsService, PopupsService } from '@services';
import { aesDecryption, ConstantsUtil, encryptDecrypt } from '@utils';
import { getPopupErrorMessage } from '@helpers';
import { ApiResponse, Feature, Popups, Routes } from '@enums';
import { i18n } from '@localization';
/**
 * Error interceptor, catch all API errors
 *
 * @author Mikhail Siutsou
 * @function ErrorInterceptor
 * @category Interceptors
 * @param {AxiosError<ApiError>} error api error.
 * @return {Promise<ApiError>} api error.
 */

var ErrorInterceptor = function ErrorInterceptor(error) {
  var _error$config;

  var disableInterception = (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.disableInterception;
  var errorObject = {
    status: undefined,
    cause: undefined,
    name: '',
    stack: '',
    message: '',
    errorCode: undefined,
    data: null
  }; // const errorRedirect = error.config.errorRedirect;

  /**
   * Redirect to error page handler.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var redirectToErrorPage = function redirectToErrorPage(error) {
    if (disableInterception) return;
    history.push(Routes.NotFound);
  };

  if (error.response) {
    var _error$response, _error$response2, _error$response2$data, _error$response5, _error$response6, _error$response7, _error$response7$data, _error$response8, _error$response8$data, _error$response9, _error$response9$data, _error$response10, _error$response10$dat, _error$response11, _error$response11$dat;

    if (typeof (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) === 'string' && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.length) > 0) {
      if (FeaturesService.available(Feature.E2EE)) {
        var _error$response3;

        var ct = sessionStorage.getItem(ConstantsUtil.localStorage.mlSecret);
        var decryptedData = aesDecryption(Buffer.from(error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data, 'base64'), Buffer.from(ct || '', 'base64')); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

        error.response.data = JSON.parse(decryptedData.toString('utf-8'));
      } else {
        var _error$response4;

        var password = sessionStorage.getItem(ConstantsUtil.localStorage.randomString);
        var encryptedSixKey = sessionStorage.getItem(ConstantsUtil.localStorage.sixKey);
        var sixKey = encryptDecrypt(encryptedSixKey || '', password || '');

        var _decryptedData = aesDecryption(Buffer.from(error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data, 'base64'), Buffer.from(sixKey, 'base64')); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment


        error.response.data = JSON.parse(_decryptedData.toString('utf-8'));
      }
    }

    errorObject.data = error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data; // Request made and server responded

    errorObject.status = error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status;
    errorObject.name = (error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : (_error$response7$data = _error$response7.data) === null || _error$response7$data === void 0 ? void 0 : _error$response7$data.name) || (error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : (_error$response8$data = _error$response8.data) === null || _error$response8$data === void 0 ? void 0 : _error$response8$data.error);
    errorObject.message = (error === null || error === void 0 ? void 0 : (_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : (_error$response9$data = _error$response9.data) === null || _error$response9$data === void 0 ? void 0 : _error$response9$data.message) || (error === null || error === void 0 ? void 0 : (_error$response10 = error.response) === null || _error$response10 === void 0 ? void 0 : (_error$response10$dat = _error$response10.data) === null || _error$response10$dat === void 0 ? void 0 : _error$response10$dat.error_description);
    errorObject.errorCode = error === null || error === void 0 ? void 0 : (_error$response11 = error.response) === null || _error$response11 === void 0 ? void 0 : (_error$response11$dat = _error$response11.data) === null || _error$response11$dat === void 0 ? void 0 : _error$response11$dat.errorCode;

    switch (error.response.status) {
      case ApiResponse.Unauthorized:
        {
          ModalsService.closeAllModals();
          PopupsService.closeAll();
          sessionStorage.clear();
          history.push(Routes.Login);
          break;
        }

      case ApiResponse.NotFound:
        {
          redirectToErrorPage(errorObject);
          break;
        }

      case ApiResponse.NotImplemented:
      case ApiResponse.BadGateway:
      case ApiResponse.ServiceUnavailable:
      case ApiResponse.GatewayTimeout:
        {
          var token = sessionStorage.getItem('token');

          if (!token) {
            history.push(Routes.Login);
          }

          void PopupsService.open(Popups.Default, {
            header: i18n.t('components.popups.errorOccurred'),
            body: i18n.t('components.popups.errorText'),
            acceptButton: i18n.t('components.popups.ok'),
            width: 270,
            maxWidth: 'xs'
          })["catch"](function () {// ToDo: error handling
          });
          break;
        }

      default:
        {// ToDo: error handling
        }
    }
  } else if (error.request) {
    // The request was made but no response was received
    errorObject.message = ConstantsUtil.errors.NETWORK_ERROR;
    redirectToErrorPage(errorObject);
  } else {
    // Something happened in setting up the request that triggered an Error
    errorObject.message = ConstantsUtil.errors.NETWORK_SETTING_ERROR;
  }

  var convertedError = getPopupErrorMessage(errorObject);
  return Promise.reject(convertedError);
};

export { ErrorInterceptor };